import { createContext, useContext } from 'react';
// The following disable directive for no-restricted-imports is intentional.
// We need to import it to default the http client and any access of an http
// client should be done through this context
// eslint-disable-next-line no-restricted-imports
import http from 'hub-http/clients/apiClient';
/**
 * Context that allows apps to specify a custom http client which all of
 * `customer-data-properties` will use.
 *
 * The default context value is the standard hub-http client, so it's
 * safe to access regardless of whether or not a custom client is provided.
 *
 * Support for custom clients is needed because some apps that outside of
 * the main app.hubspot.com domain (such as the SalesSidebar gmail plugin,
 * which is iframed on gmail.com). These apps need a custom http client to
 * make calls to the HubSpot backend. This context gives apps with a way to
 * provide a custom http client to use.
 *
 * @example
 * import http from 'hub-http/clients/apiClient';
 * import { HttpClientContext } from 'customer-data-properties/client/HttpClientContext';
 *
 * <HttpClientContext.Provider value={http}>
 *   ...
 * </HttpClientContext.Provider>
 */
export const HttpClientContext = /*#__PURE__*/createContext(http);
export const useHttpClient = () => useContext(HttpClientContext);